
// import React, { useState, useEffect, useCallback } from 'react';
// import styles from './InvoiceTable.module.css';
// import * as XLSX from 'xlsx';
// import { allInvoiceApi } from '../../../../../api/allInvoice/allInvoiceApi';
// import InvoiceCard from './InvoiceCard';

// const InvoiceTable = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalItems, setTotalItems] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedYear, setSelectedYear] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');
//   const [selectedStatus, setSelectedStatus] = useState('');
//   const [sortBy, setSortBy] = useState('');
//   const [sortOrder, setSortOrder] = useState('desc');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [availableYears, setAvailableYears] = useState([]);
//   const [pdfAvailability, setPdfAvailability] = useState({});
//   const [downloadingPdf, setDownloadingPdf] = useState({});
//   const [downloadingCoa, setDownloadingCoa] = useState({});
//   const itemsPerPage = 20;

//   const months = [
//     { label: 'All Months', value: '' },
//     { label: 'January', value: '1' },
//     { label: 'February', value: '2' },
//     { label: 'March', value: '3' },
//     { label: 'April', value: '4' },
//     { label: 'May', value: '5' },
//     { label: 'June', value: '6' },
//     { label: 'July', value: '7' },
//     { label: 'August', value: '8' },
//     { label: 'September', value: '9' },
//     { label: 'October', value: '10' },
//     { label: 'November', value: '11' },
//     { label: 'December', value: '12' }
//   ];

//   // Removed "Partially Open" as requested
//   const statusFilters = [
//     { label: 'All', value: '' },
//     { label: 'Open', value: 'Open' },
//     { label: 'Closed', value: 'Closed' },
//     { label: 'Cancelled', value: 'Cancelled' }
//   ];

//   // Fetch available years
//   useEffect(() => {
//     const fetchYears = async () => {
//       try {
//         const data = await allInvoiceApi.getInvoiceYears();
//         if (data && Array.isArray(data)) setAvailableYears(data);
//       } catch {
//         const currentYear = new Date().getFullYear();
//         const years = [];
//         for (let y = currentYear; y >= 2023; y--) years.push(y.toString());
//         setAvailableYears(years);
//       }
//     };
//     fetchYears();
//   }, []);

//   const fetchInvoices = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const data = await allInvoiceApi.getAllInvoices(
//         currentPage,
//         itemsPerPage,
//         searchTerm,
//         selectedMonth,
//         selectedStatus,
//         sortBy,
//         sortOrder,
//         selectedYear
//       );

//       if (data && data.invoices && Array.isArray(data.invoices)) {
//         setInvoices(data.invoices);
//         setTotalPages(data.totalPages || 0);
//         setTotalItems(data.totalItems || 0);
//       } else {
//         setInvoices([]);
//         setError('Invalid data received from server');
//       }
//     } catch {
//       setError('Failed to load invoices');
//       setInvoices([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, searchTerm, selectedMonth, selectedStatus, sortBy, sortOrder, selectedYear]);

//   // Debounced auto-search
//   useEffect(() => {
//     const timer = setTimeout(() => { setCurrentPage(0); }, 400);
//     return () => clearTimeout(timer);
//   }, [searchTerm]);

//   useEffect(() => {
//     fetchInvoices();
//   }, [fetchInvoices]);

//   // Check PDF availability when invoices change
//   useEffect(() => {
//     if (invoices.length === 0) { setPdfAvailability({}); return; }
//     const check = async () => {
//       const results = await Promise.all(
//         invoices.map(async (inv) => {
//           const r = await allInvoiceApi.checkInvoicePdfExists(inv.invoiceNo);
//           return [inv.invoiceNo, r?.exists === true];
//         })
//       );
//       const map = {};
//       results.forEach(([no, exists]) => { map[no] = exists; });
//       setPdfAvailability(map);
//     };
//     check();
//   }, [invoices]);

//   const handleDownloadPdf = async (invoiceNo, e) => {
//     e.stopPropagation();
//     try {
//       setDownloadingPdf(prev => ({ ...prev, [invoiceNo]: true }));
//       await allInvoiceApi.downloadInvoicePdf(invoiceNo);
//     } catch {
//       alert('Failed to download PDF. Please try again.');
//     } finally {
//       setDownloadingPdf(prev => ({ ...prev, [invoiceNo]: false }));
//     }
//   };

//   // COA download - uses coaNo field to determine source
//   // coaNo='N/A' or empty = no COA; otherwise try density first, fallback energy
//   const handleDownloadCoa = async (invoice, e) => {
//     e.stopPropagation();
//     const key = `${invoice.invoiceNo}-${invoice.lineNum}`;
//     try {
//       setDownloadingCoa(prev => ({ ...prev, [key]: true }));
//       // Use vendorBatchNo and itemCode for COA download
//       // Try density COA first; if it fails, try energy
//       try {
//         await allInvoiceApi.downloadDensityCoa(invoice.itemCode, invoice.vendorBatchNo);
//       } catch {
//         await allInvoiceApi.downloadEnergyCoa(invoice.itemCode, invoice.vendorBatchNo);
//       }
//     } catch {
//       alert('COA not available for download.');
//     } finally {
//       setDownloadingCoa(prev => ({ ...prev, [key]: false }));
//     }
//   };

//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setSelectedYear('');
//     setSelectedMonth('');
//     setSelectedStatus('');
//     setSortBy('');
//     setSortOrder('desc');
//     setCurrentPage(0);
//   };

//   const handleYearChange = (value) => { setSelectedYear(value); setCurrentPage(0); };
//   const handleMonthChange = (value) => { setSelectedMonth(value); setCurrentPage(0); };
//   const handleStatusChange = (value) => { setSelectedStatus(value); setCurrentPage(0); };

//   const handleSort = (column) => {
//     if (sortBy === column) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(column);
//       setSortOrder('asc');
//     }
//     setCurrentPage(0);
//   };

//   const handleInvoiceClick = async (invoiceNo, lineNum) => {
//     try {
//       setLoading(true);
//       const invoiceDetails = await allInvoiceApi.getInvoiceLineDetails(invoiceNo, lineNum);
//       setSelectedInvoice(invoiceDetails);
//       setIsModalOpen(true);
//     } catch {
//       alert('Failed to load invoice details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseModal = () => { setIsModalOpen(false); setSelectedInvoice(null); };

//   const handleExportExcel = async () => {
//     try {
//       setLoading(true);
//       const data = await allInvoiceApi.exportAllInvoices(
//         searchTerm, selectedMonth, selectedStatus, selectedYear
//       );
//       if (!data || !Array.isArray(data) || data.length === 0) {
//         alert('No data to export');
//         return;
//       }
//       const worksheet = XLSX.utils.json_to_sheet(data.map(invoice => ({
//         'Invoice No': invoice.invoiceNo,
//         'Invoice Posting Date': invoice.invoicePostingDate,
//         'Dispatch Date': invoice.dispatchDate,
//         'Tracking No': invoice.trackingNo,
//         'Courier Service': invoice.courierService,
//         'SO No': invoice.soNo,
//         'SO Date': invoice.soDate,
//         'Customer PO No': invoice.customerPoNo,
//         'Customer Name': invoice.customerName,
//         'Contact Person': invoice.contactPerson,
//         'Sales Employee': invoice.salesEmployee,
//         'Delivery Date': invoice.deliveryDate,
//         'Ship Date': invoice.shipDate,
//         'Status': invoice.status,
//         'Item Code': invoice.itemCode,
//         'Description': invoice.description,
//         'CAS No': invoice.casNo,
//         'Category': invoice.categoryName,
//         'Vendor Catalog No.': invoice.vendorCatalogNo,
//         'Pack Size': invoice.packSize,
//         'Ordered Qty': invoice.orderedQty,
//         'Open Qty': invoice.openQty,
//         'Delivered Qty': invoice.deliveredQty,
//         'Stock Status (Hyd)': invoice.stockStatus,
//         'Planned Delivery Date': invoice.plannedDeliveryDate,
//         'Mkt Feedback': invoice.mktFeedback,
//         'Unit Price': invoice.unitPrice,
//         'Line Total': invoice.lineTotal,
//         'Discount %': invoice.discountPercent,
//         'Tax %': invoice.taxPercent,
//         'Currency': invoice.currency,
//         'Batch No': invoice.batchNo,
//         'Subtotal': invoice.subtotal,
//         'Tax Total': invoice.taxTotal,
//         'Discount Total': invoice.discountTotal,
//         'Total Amount': invoice.totalAmount,
//         'Payment Terms': invoice.paymentTerms
//       })));
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'All Invoices');
//       XLSX.writeFile(workbook, `all_invoices_${new Date().toISOString().split('T')[0]}.xlsx`);
//     } catch {
//       alert('Failed to export data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatCurrency = (amount, currency = 'INR') => {
//     const symbol = currency === 'USD' ? '$' : '₹';
//     return symbol + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
//   };

//   const getSortIcon = (column) => {
//     if (sortBy !== column) return '⇅';
//     return sortOrder === 'asc' ? '↑' : '↓';
//   };

//   const hasActiveFilters = searchTerm || selectedYear || selectedMonth || selectedStatus;

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.filtersSection}>
//         {/* Auto-search - no button */}
//         <div className={styles.searchRow}>
//           <div className={styles.searchInputWrapper}>
//             <span className={styles.searchIcon}>🔍</span>
//             <input
//               type="text"
//               placeholder="Search by Invoice#, SO#, Customer, Item Code, Description, Batch..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className={styles.searchInput}
//             />
//             {searchTerm && (
//               <button onClick={() => setSearchTerm('')} className={styles.clearSearchButton} title="Clear search">
//                 ✕
//               </button>
//             )}
//           </div>
//         </div>

//         <div className={styles.filterRow}>
//           <div className={styles.filterGroupRow}>
//             <div className={styles.filterGroup}>
//               <label className={styles.filterLabel}>Year:</label>
//               <select
//                 value={selectedYear}
//                 onChange={(e) => handleYearChange(e.target.value)}
//                 className={styles.filterSelect}
//                 disabled={loading}
//               >
//                 <option value="">All Years</option>
//                 {availableYears.map((year) => (
//                   <option key={year} value={year}>{year}</option>
//                 ))}
//               </select>
//             </div>

//             <div className={styles.filterGroup}>
//               <label className={styles.filterLabel}>Month:</label>
//               <select
//                 value={selectedMonth}
//                 onChange={(e) => handleMonthChange(e.target.value)}
//                 className={styles.filterSelect}
//                 disabled={loading}
//               >
//                 {months.map((month) => (
//                   <option key={month.value} value={month.value}>{month.label}</option>
//                 ))}
//               </select>
//             </div>

//             <div className={styles.statusButtonGroup}>
//               {statusFilters.map((filter) => (
//                 <button
//                   key={filter.value}
//                   className={`${styles.statusButton} ${selectedStatus === filter.value ? styles.statusButtonActive : ''}`}
//                   onClick={() => handleStatusChange(filter.value)}
//                   disabled={loading}
//                 >
//                   {filter.label}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div className={styles.actionButtons}>
//             <button onClick={handleClearFilters} disabled={loading} className={styles.clearButton}>
//               Clear All Filters
//             </button>
//             <button onClick={handleExportExcel} disabled={loading || totalItems === 0} className={styles.excelButton}>
//               <span className={styles.excelIcon}>📊</span>
//               Export Excel
//             </button>
//           </div>
//         </div>
//       </div>

//       {hasActiveFilters && (
//         <div className={styles.activeFilters}>
//           <span className={styles.activeFiltersLabel}>Active Filters:</span>
//           {searchTerm && (
//             <div className={styles.filterTag}>
//               Search: "{searchTerm}"
//               <button onClick={() => setSearchTerm('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//           {selectedYear && (
//             <div className={styles.filterTag}>
//               Year: {selectedYear}
//               <button onClick={() => handleYearChange('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//           {selectedMonth && (
//             <div className={styles.filterTag}>
//               Month: {months.find(m => m.value === selectedMonth)?.label}
//               <button onClick={() => handleMonthChange('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//           {selectedStatus && (
//             <div className={styles.filterTag}>
//               Status: {selectedStatus}
//               <button onClick={() => handleStatusChange('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//         </div>
//       )}

//       {error && <div className={styles.errorMessage}>{error}</div>}

//       {loading && (
//         <div className={styles.loadingContainer}>
//           <div className={styles.loadingSpinner} />
//           <div className={styles.loadingText}>Loading invoices...</div>
//         </div>
//       )}

//       {!loading && (
//         <div className={styles.tableContainer}>
//           <div className={styles.tableWrapper}>
//             <table className={styles.table}>
//               <thead>
//                 <tr>
//                   <th className={styles.th} onClick={() => handleSort('invoiceNo')}>
//                     Invoice No {getSortIcon('invoiceNo')}
//                   </th>
//                   <th className={styles.th} onClick={() => handleSort('invoicePostingDate')}>
//                     Invoice Date {getSortIcon('invoicePostingDate')}
//                   </th>
//                   <th className={styles.th}>Dispatch Date</th>
//                   <th className={styles.th}>Tracking No</th>
//                   <th className={styles.th}>Courier Service</th>
//                   <th className={styles.th}>SO No</th>
//                   <th className={styles.th}>SO Date</th>
//                   <th className={styles.th}>Customer PO No</th>
//                   <th className={styles.th}>Customer Name</th>
//                   <th className={styles.th}>Contact Person</th>
//                   <th className={styles.th}>Sales Employee</th>
//                   <th className={styles.th}>Delivery Date</th>
//                   <th className={styles.th}>Ship Date</th>
//                   <th className={styles.th} onClick={() => handleSort('status')}>
//                     Status {getSortIcon('status')}
//                   </th>
//                   <th className={styles.th}>COA</th>
//                   <th className={styles.th}>Item Code</th>
//                   <th className={styles.th}>Description</th>
//                   <th className={styles.th}>CAS No</th>
//                   <th className={styles.th}>Category</th>
//                   <th className={styles.th}>Vendor Catalog No.</th>
//                   <th className={styles.th}>Pack Size</th>
//                   <th className={styles.th}>Ordered Qty</th>
//                   <th className={styles.th}>Open Qty</th>
//                   <th className={styles.th}>Delivered Qty</th>
//                   <th className={styles.th}>Stock Status - In Hyd</th>
//                   <th className={styles.th}>Planned Delivery</th>
//                   <th className={styles.th}>Mkt Feedback</th>
//                   <th className={styles.th} onClick={() => handleSort('unitPrice')}>
//                     Unit Price {getSortIcon('unitPrice')}
//                   </th>
//                   <th className={styles.th} onClick={() => handleSort('lineTotal')}>
//                     Line Total {getSortIcon('lineTotal')}
//                   </th>
//                   <th className={styles.th}>Discount %</th>
//                   <th className={styles.th}>Tax %</th>
//                   <th className={styles.th}>Currency</th>
//                   <th className={styles.th}>Batch No</th>
//                   <th className={styles.th}>Subtotal</th>
//                   <th className={styles.th}>Tax Total</th>
//                   <th className={styles.th}>Discount Total</th>
//                   <th className={styles.th} onClick={() => handleSort('totalAmount')}>
//                     Total Amount {getSortIcon('totalAmount')}
//                   </th>
//                   <th className={styles.th}>Payment Terms</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {invoices.length > 0 ? (
//                   invoices.map((invoice, index) => {
//                     const hasPdf = pdfAvailability[invoice.invoiceNo] === true;
//                     const isPdfDownloading = downloadingPdf[invoice.invoiceNo] === true;
//                     const coaKey = `${invoice.invoiceNo}-${invoice.lineNum}`;
//                     const hasCoA = invoice.coaNo && invoice.coaNo !== 'N/A';
//                     const isCoaDownloading = downloadingCoa[coaKey] === true;

//                     return (
//                       <tr key={`${invoice.invoiceNo}-${invoice.lineNum}-${index}`} className={styles.tr}>
//                         {/* Invoice No + PDF button */}
//                         <td className={styles.td}>
//                           <div className={styles.cellWithAction}>
//                             <button
//                               onClick={() => handleInvoiceClick(invoice.invoiceNo, invoice.lineNum)}
//                               className={styles.linkButton}
//                             >
//                               {invoice.invoiceNo}
//                             </button>
//                             {hasPdf && (
//                               <button
//                                 onClick={(e) => handleDownloadPdf(invoice.invoiceNo, e)}
//                                 disabled={isPdfDownloading}
//                                 className={styles.downloadInvoiceButton}
//                                 title="Download Invoice PDF"
//                               >
//                                 {isPdfDownloading ? '...' : 'Invoice PDF'}
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                         <td className={styles.td}>{formatDate(invoice.invoicePostingDate)}</td>
//                         <td className={styles.td}>{formatDate(invoice.dispatchDate)}</td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.trackingNo || 'N/A'}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.courierService || 'N/A'}</div></td>
//                         <td className={styles.td}>{invoice.soNo || 'N/A'}</td>
//                         <td className={styles.td}>{formatDate(invoice.soDate)}</td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.customerPoNo || 'N/A'}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.customerName}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.contactPerson || 'N/A'}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.salesEmployee || 'N/A'}</div></td>
//                         <td className={styles.td}>{formatDate(invoice.deliveryDate)}</td>
//                         <td className={styles.td}>{formatDate(invoice.shipDate)}</td>
//                         <td className={styles.td}>
//                           <span className={`${styles.statusBadge} ${styles[`status${invoice.status?.replace(/\s+/g, '')}`]}`}>
//                             {invoice.status}
//                           </span>
//                         </td>
//                         {/* COA Download - before Item Code */}
//                         <td className={styles.td}>
//                           {hasCoA ? (
//                             <button
//                               onClick={(e) => handleDownloadCoa(invoice, e)}
//                               disabled={isCoaDownloading}
//                               className={styles.downloadCoaButton}
//                               title="Download COA"
//                             >
//                               {isCoaDownloading ? '...' : 'COA'}
//                             </button>
//                           ) : (
//                             <span className={styles.naText}>N/A</span>
//                           )}
//                         </td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.itemCode}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.description}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.casNo || 'N/A'}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.categoryName || 'N/A'}</div></td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.vendorCatalogNo || 'N/A'}</div></td>
//                         <td className={styles.td}>{invoice.packSize || 0}</td>
//                         <td className={styles.td}>{invoice.orderedQty}</td>
//                         <td className={styles.td}>{invoice.openQty}</td>
//                         <td className={styles.td}>{invoice.deliveredQty}</td>
//                         <td className={styles.td}>
//                           <span className={`${styles.stockBadge} ${invoice.stockStatus === 'In Stock' ? styles.inStock : styles.outOfStock}`}>
//                             {invoice.stockStatus}
//                           </span>
//                         </td>
//                         <td className={styles.td}>{formatDate(invoice.plannedDeliveryDate)}</td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.mktFeedback || 'N/A'}</div></td>
//                         <td className={styles.td}>{formatCurrency(invoice.unitPrice, invoice.currency)}</td>
//                         <td className={styles.td}>{formatCurrency(invoice.lineTotal, invoice.currency)}</td>
//                         <td className={styles.td}>{invoice.discountPercent}%</td>
//                         <td className={styles.td}>{invoice.taxPercent}%</td>
//                         <td className={styles.td}>{invoice.currency}</td>
//                         <td className={styles.td}><div className={styles.truncate}>{invoice.batchNo || 'N/A'}</div></td>
//                         <td className={styles.td}>{formatCurrency(invoice.subtotal, invoice.currency)}</td>
//                         <td className={styles.td}>{formatCurrency(invoice.taxTotal, invoice.currency)}</td>
//                         <td className={styles.td}>{formatCurrency(invoice.discountTotal, invoice.currency)}</td>
//                         <td className={styles.td}>
//                           <span className={styles.totalAmount}>
//                             {formatCurrency(invoice.totalAmount, invoice.currency)}
//                           </span>
//                         </td>
//                         <td className={styles.td}>{invoice.paymentTerms || 'N/A'}</td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td className={styles.td} colSpan="38" style={{ textAlign: 'center', padding: '40px' }}>
//                       {hasActiveFilters ? 'No invoices match your filters' : 'No invoices found'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {!loading && invoices.length > 0 && (
//         <div className={styles.paginationSection}>
//           <div className={styles.paginationInfo}>
//             Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems} records
//           </div>
//           <div className={styles.paginationControls}>
//             <button onClick={() => setCurrentPage(0)} disabled={currentPage === 0} className={styles.paginationButton}>First</button>
//             <button onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))} disabled={currentPage === 0} className={styles.paginationButton}>Prev</button>
//             <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
//             <button onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Next</button>
//             <button onClick={() => setCurrentPage(totalPages - 1)} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Last</button>
//           </div>
//         </div>
//       )}

//       {isModalOpen && selectedInvoice && (
//         <InvoiceCard invoice={selectedInvoice} onClose={handleCloseModal} />
//       )}
//     </div>
//   );
// };

// export default InvoiceTable;

import React, { useState, useEffect, useCallback } from 'react';
import styles from './InvoiceTable.module.css';
import * as XLSX from 'xlsx';
import { allInvoiceApi } from '../../../../../api/allInvoice/allInvoiceApi';
import InvoiceCard from './InvoiceCard';

const InvoiceTable = () => {
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState('desc');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [availableYears, setAvailableYears] = useState([]);
  const [pdfAvailability, setPdfAvailability] = useState({});
  const [downloadingPdf, setDownloadingPdf] = useState({});
  const [downloadingCoa, setDownloadingCoa] = useState({});
  const itemsPerPage = 20;

  const months = [
    { label: 'All Months', value: '' },
    { label: 'January', value: '1' },
    { label: 'February', value: '2' },
    { label: 'March', value: '3' },
    { label: 'April', value: '4' },
    { label: 'May', value: '5' },
    { label: 'June', value: '6' },
    { label: 'July', value: '7' },
    { label: 'August', value: '8' },
    { label: 'September', value: '9' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' }
  ];

  const statusFilters = [
    { label: 'All', value: '' },
    { label: 'Open', value: 'Open' },
    { label: 'Closed', value: 'Closed' },
    { label: 'Cancelled', value: 'Cancelled' }
  ];

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const data = await allInvoiceApi.getInvoiceYears();
        if (data && Array.isArray(data)) setAvailableYears(data);
      } catch {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let y = currentYear; y >= 2023; y--) years.push(y.toString());
        setAvailableYears(years);
      }
    };
    fetchYears();
  }, []);

  const fetchInvoices = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await allInvoiceApi.getAllInvoices(
        currentPage, itemsPerPage, searchTerm, selectedMonth,
        selectedStatus, sortBy, sortOrder, selectedYear
      );
      if (data && data.invoices && Array.isArray(data.invoices)) {
        setInvoices(data.invoices);
        setTotalPages(data.totalPages || 0);
        setTotalItems(data.totalItems || 0);
      } else {
        setInvoices([]);
        setError('Invalid data received from server');
      }
    } catch {
      setError('Failed to load invoices');
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm, selectedMonth, selectedStatus, sortBy, sortOrder, selectedYear]);

  useEffect(() => {
    const timer = setTimeout(() => { setCurrentPage(0); }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => { fetchInvoices(); }, [fetchInvoices]);

  useEffect(() => {
    if (invoices.length === 0) { setPdfAvailability({}); return; }
    const check = async () => {
      const results = await Promise.all(
        invoices.map(async (inv) => {
          const r = await allInvoiceApi.checkInvoicePdfExists(inv.invoiceNo);
          return [inv.invoiceNo, r?.exists === true];
        })
      );
      const map = {};
      results.forEach(([no, exists]) => { map[no] = exists; });
      setPdfAvailability(map);
    };
    check();
  }, [invoices]);

  const handleDownloadPdf = async (invoiceNo, e) => {
    e.stopPropagation();
    try {
      setDownloadingPdf(prev => ({ ...prev, [invoiceNo]: true }));
      await allInvoiceApi.downloadInvoicePdf(invoiceNo);
    } catch {
      alert('Failed to download PDF. Please try again.');
    } finally {
      setDownloadingPdf(prev => ({ ...prev, [invoiceNo]: false }));
    }
  };

  const handleDownloadCoa = async (invoice, e) => {
    e.stopPropagation();
    const key = `${invoice.invoiceNo}-${invoice.lineNum}`;
    try {
      setDownloadingCoa(prev => ({ ...prev, [key]: true }));
      try {
        await allInvoiceApi.downloadDensityCoa(invoice.itemCode, invoice.vendorBatchNo);
      } catch {
        await allInvoiceApi.downloadEnergyCoa(invoice.itemCode, invoice.vendorBatchNo);
      }
    } catch {
      alert('COA not available for download.');
    } finally {
      setDownloadingCoa(prev => ({ ...prev, [key]: false }));
    }
  };

  const handleClearFilters = () => {
    setSearchTerm(''); setSelectedYear(''); setSelectedMonth('');
    setSelectedStatus(''); setSortBy(''); setSortOrder('desc'); setCurrentPage(0);
  };

  const handleYearChange = (value) => { setSelectedYear(value); setCurrentPage(0); };
  const handleMonthChange = (value) => { setSelectedMonth(value); setCurrentPage(0); };
  const handleStatusChange = (value) => { setSelectedStatus(value); setCurrentPage(0); };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
    setCurrentPage(0);
  };

  const handleInvoiceClick = async (invoiceNo, lineNum) => {
    try {
      setLoading(true);
      const invoiceDetails = await allInvoiceApi.getInvoiceLineDetails(invoiceNo, lineNum);
      setSelectedInvoice(invoiceDetails);
      setIsModalOpen(true);
    } catch {
      alert('Failed to load invoice details');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => { setIsModalOpen(false); setSelectedInvoice(null); };

  const handleExportExcel = async () => {
    try {
      setLoading(true);
      const data = await allInvoiceApi.exportAllInvoices(searchTerm, selectedMonth, selectedStatus, selectedYear);
      if (!data || !Array.isArray(data) || data.length === 0) { alert('No data to export'); return; }
      const worksheet = XLSX.utils.json_to_sheet(data.map(invoice => ({
        'Invoice No': invoice.invoiceNo,
        'Invoice Posting Date': invoice.invoicePostingDate,
        'Dispatch Date': invoice.dispatchDate,
        'Tracking No': invoice.trackingNo,
        'Courier Service': invoice.courierService,
        'SO No': invoice.soNo,
        'SO Date': invoice.soDate,
        'Customer PO No': invoice.customerPoNo,
        'Customer Name': invoice.customerName,
        'Contact Person': invoice.contactPerson,
        'Sales Employee': invoice.salesEmployee,
        'Delivery Date': invoice.deliveryDate,
        'Ship Date': invoice.shipDate,
        'Status': invoice.status,
        'Item Code': invoice.itemCode,
        'Description': invoice.description,
        'CAS No': invoice.casNo,
        'Category': invoice.categoryName,
        'Vendor Catalog No.': invoice.vendorCatalogNo,
        'Pack Size': invoice.packSize,
        'Ordered Qty': invoice.orderedQty,
        'Open Qty': invoice.openQty,
        'Delivered Qty': invoice.deliveredQty,
        'Stock Status (Hyd)': invoice.stockStatus,
        'Planned Delivery Date': invoice.plannedDeliveryDate,
        'Mkt Feedback': invoice.mktFeedback,
        'Unit Price': invoice.unitPrice,
        'Line Total': invoice.lineTotal,
        'Discount %': invoice.discountPercent,
        'Tax %': invoice.taxPercent,
        'Currency': invoice.currency,
        'Batch No': invoice.batchNo,
        'Subtotal': invoice.subtotal,
        'Tax Total': invoice.taxTotal,
        'Discount Total': invoice.discountTotal,
        'Total Amount': invoice.totalAmount,
        'Payment Terms': invoice.paymentTerms
      })));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'All Invoices');
      XLSX.writeFile(workbook, `all_invoices_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch {
      alert('Failed to export data');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount, currency = 'INR') => {
    const symbol = currency === 'USD' ? '$' : '₹';
    return symbol + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getSortIcon = (column) => {
    if (sortBy !== column) return '⇅';
    return sortOrder === 'asc' ? '↑' : '↓';
  };

  const hasActiveFilters = searchTerm || selectedYear || selectedMonth || selectedStatus;

  return (
    <div className={styles.wrapper}>
      <div className={styles.filtersSection}>
        <div className={styles.searchRow}>
          <div className={styles.searchInputWrapper}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              type="text"
              placeholder="Search by Invoice#, SO#, Customer, Item Code, CAS No, Tracking#..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button onClick={() => setSearchTerm('')} className={styles.clearSearchButton} title="Clear search">✕</button>
            )}
          </div>
        </div>

        <div className={styles.filterRow}>
          <div className={styles.filterGroupRow}>
            <div className={styles.filterGroup}>
              <label className={styles.filterLabel}>Year:</label>
              <select value={selectedYear} onChange={(e) => handleYearChange(e.target.value)} className={styles.filterSelect} disabled={loading}>
                <option value="">All Years</option>
                {availableYears.map((year) => (<option key={year} value={year}>{year}</option>))}
              </select>
            </div>
            <div className={styles.filterGroup}>
              <label className={styles.filterLabel}>Month:</label>
              <select value={selectedMonth} onChange={(e) => handleMonthChange(e.target.value)} className={styles.filterSelect} disabled={loading}>
                {months.map((month) => (<option key={month.value} value={month.value}>{month.label}</option>))}
              </select>
            </div>
            <div className={styles.statusButtonGroup}>
              {statusFilters.map((filter) => (
                <button
                  key={filter.value}
                  className={`${styles.statusButton} ${selectedStatus === filter.value ? styles.statusButtonActive : ''}`}
                  onClick={() => handleStatusChange(filter.value)}
                  disabled={loading}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
          <div className={styles.actionButtons}>
            <button onClick={handleClearFilters} disabled={loading} className={styles.clearButton}>Clear All Filters</button>
            <button onClick={handleExportExcel} disabled={loading || totalItems === 0} className={styles.excelButton}>
              <span className={styles.excelIcon}>📊</span>Export Excel
            </button>
          </div>
        </div>
      </div>

      {hasActiveFilters && (
        <div className={styles.activeFilters}>
          <span className={styles.activeFiltersLabel}>Active Filters:</span>
          {searchTerm && (
            <div className={styles.filterTag}>Search: "{searchTerm}"<button onClick={() => setSearchTerm('')} className={styles.removeFilterButton}>✕</button></div>
          )}
          {selectedYear && (
            <div className={styles.filterTag}>Year: {selectedYear}<button onClick={() => handleYearChange('')} className={styles.removeFilterButton}>✕</button></div>
          )}
          {selectedMonth && (
            <div className={styles.filterTag}>Month: {months.find(m => m.value === selectedMonth)?.label}<button onClick={() => handleMonthChange('')} className={styles.removeFilterButton}>✕</button></div>
          )}
          {selectedStatus && (
            <div className={styles.filterTag}>Status: {selectedStatus}<button onClick={() => handleStatusChange('')} className={styles.removeFilterButton}>✕</button></div>
          )}
        </div>
      )}

      {error && <div className={styles.errorMessage}>{error}</div>}

      {loading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} />
          <div className={styles.loadingText}>Loading invoices...</div>
        </div>
      )}

      {!loading && (
        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th} onClick={() => handleSort('invoiceNo')}>Invoice No {getSortIcon('invoiceNo')}</th>
                  <th className={styles.th} onClick={() => handleSort('invoicePostingDate')}>Invoice Date {getSortIcon('invoicePostingDate')}</th>
                  <th className={styles.th}>Dispatch Date</th>
                  <th className={styles.th}>Tracking No</th>
                  <th className={styles.th}>Courier Service</th>
                  <th className={styles.th}>SO No</th>
                  <th className={styles.th}>SO Date</th>
                  <th className={styles.th}>Customer PO No</th>
                  <th className={styles.th}>Customer Name</th>
                  <th className={styles.th}>Contact Person</th>
                  <th className={styles.th}>Sales Employee</th>
                  <th className={styles.th}>Delivery Date</th>
                  <th className={styles.th}>Ship Date</th>
                  <th className={styles.th} onClick={() => handleSort('status')}>Status {getSortIcon('status')}</th>
                  <th className={styles.th}>COA</th>
                  <th className={styles.th}>Item Code</th>
                  <th className={styles.th}>Description</th>
                  <th className={styles.th}>CAS No</th>
                  <th className={styles.th}>Category</th>
                  <th className={styles.th}>Vendor Catalog No.</th>
                  <th className={styles.th}>Pack Size</th>
                  <th className={styles.th}>Ordered Qty</th>
                  <th className={styles.th}>Open Qty</th>
                  <th className={styles.th}>Delivered Qty</th>
                  <th className={styles.th}>Stock Status - In Hyd</th>
                  <th className={styles.th}>Planned Delivery</th>
                  <th className={styles.th}>Mkt Feedback</th>
                  <th className={styles.th} onClick={() => handleSort('unitPrice')}>Unit Price {getSortIcon('unitPrice')}</th>
                  <th className={styles.th} onClick={() => handleSort('lineTotal')}>Line Total {getSortIcon('lineTotal')}</th>
                  <th className={styles.th}>Discount %</th>
                  <th className={styles.th}>Tax %</th>
                  <th className={styles.th}>Currency</th>
                  <th className={styles.th}>Batch No</th>
                  <th className={styles.th}>Subtotal</th>
                  <th className={styles.th}>Tax Total</th>
                  <th className={styles.th}>Discount Total</th>
                  <th className={styles.th} onClick={() => handleSort('totalAmount')}>Total Amount {getSortIcon('totalAmount')}</th>
                  <th className={styles.th}>Payment Terms</th>
                </tr>
              </thead>
              <tbody>
                {invoices.length > 0 ? (
                  invoices.map((invoice, index) => {
                    const hasPdf = pdfAvailability[invoice.invoiceNo] === true;
                    const isPdfDownloading = downloadingPdf[invoice.invoiceNo] === true;
                    const coaKey = `${invoice.invoiceNo}-${invoice.lineNum}`;
                    const hasCoA = invoice.coaNo && invoice.coaNo !== 'N/A';
                    const isCoaDownloading = downloadingCoa[coaKey] === true;

                    return (
                      <tr key={`${invoice.invoiceNo}-${invoice.lineNum}-${index}`} className={styles.tr}>
                        {/* Invoice No — no underline, just click to open modal + optional PDF button */}
                        <td className={styles.td}>
                          <div className={styles.cellWithAction}>
                            <span
                              onClick={() => handleInvoiceClick(invoice.invoiceNo, invoice.lineNum)}
                              className={styles.invoiceNoCell}
                            >
                              {invoice.invoiceNo}
                            </span>
                            {hasPdf && (
                              <button
                                onClick={(e) => handleDownloadPdf(invoice.invoiceNo, e)}
                                disabled={isPdfDownloading}
                                className={styles.downloadInvoiceButton}
                                title="Download Invoice PDF"
                              >
                                {isPdfDownloading ? '...' : 'PDF'}
                              </button>
                            )}
                          </div>
                        </td>
                        <td className={styles.td}>{formatDate(invoice.invoicePostingDate)}</td>
                        <td className={styles.td}>{formatDate(invoice.dispatchDate)}</td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.trackingNo || 'N/A'}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.courierService || 'N/A'}</div></td>
                        <td className={styles.td}>{invoice.soNo || 'N/A'}</td>
                        <td className={styles.td}>{formatDate(invoice.soDate)}</td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.customerPoNo || 'N/A'}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.customerName}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.contactPerson || 'N/A'}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.salesEmployee || 'N/A'}</div></td>
                        <td className={styles.td}>{formatDate(invoice.deliveryDate)}</td>
                        <td className={styles.td}>{formatDate(invoice.shipDate)}</td>
                        <td className={styles.td}>
                          <span className={`${styles.statusBadge} ${styles[`status${invoice.status?.replace(/\s+/g, '')}`]}`}>
                            {invoice.status}
                          </span>
                        </td>
                        <td className={styles.td}>
                          {hasCoA ? (
                            <button
                              onClick={(e) => handleDownloadCoa(invoice, e)}
                              disabled={isCoaDownloading}
                              className={styles.downloadCoaButton}
                              title="Download COA"
                            >
                              {isCoaDownloading ? '...' : 'COA'}
                            </button>
                          ) : (
                            <span className={styles.naText}>N/A</span>
                          )}
                        </td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.itemCode}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.description}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.casNo || 'N/A'}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.categoryName || 'N/A'}</div></td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.vendorCatalogNo || 'N/A'}</div></td>
                        <td className={styles.td}>{invoice.packSize || 0}</td>
                        <td className={styles.td}>{invoice.orderedQty}</td>
                        <td className={styles.td}>{invoice.openQty}</td>
                        <td className={styles.td}>{invoice.deliveredQty}</td>
                        <td className={styles.td}>
                          <span className={`${styles.stockBadge} ${invoice.stockStatus === 'In Stock' ? styles.inStock : styles.outOfStock}`}>
                            {invoice.stockStatus}
                          </span>
                        </td>
                        <td className={styles.td}>{formatDate(invoice.plannedDeliveryDate)}</td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.mktFeedback || 'N/A'}</div></td>
                        <td className={styles.td}>{formatCurrency(invoice.unitPrice, invoice.currency)}</td>
                        <td className={styles.td}>{formatCurrency(invoice.lineTotal, invoice.currency)}</td>
                        <td className={styles.td}>{invoice.discountPercent}%</td>
                        <td className={styles.td}>{invoice.taxPercent}%</td>
                        <td className={styles.td}>{invoice.currency}</td>
                        <td className={styles.td}><div className={styles.truncate}>{invoice.batchNo || 'N/A'}</div></td>
                        <td className={styles.td}>{formatCurrency(invoice.subtotal, invoice.currency)}</td>
                        <td className={styles.td}>{formatCurrency(invoice.taxTotal, invoice.currency)}</td>
                        <td className={styles.td}>{formatCurrency(invoice.discountTotal, invoice.currency)}</td>
                        <td className={styles.td}>
                          <span className={styles.totalAmount}>{formatCurrency(invoice.totalAmount, invoice.currency)}</span>
                        </td>
                        <td className={styles.td}>{invoice.paymentTerms || 'N/A'}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className={styles.td} colSpan="38" style={{ textAlign: 'center', padding: '40px' }}>
                      {hasActiveFilters ? 'No invoices match your filters' : 'No invoices found'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!loading && invoices.length > 0 && (
        <div className={styles.paginationSection}>
          <div className={styles.paginationInfo}>
            Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems} records
          </div>
          <div className={styles.paginationControls}>
            <button onClick={() => setCurrentPage(0)} disabled={currentPage === 0} className={styles.paginationButton}>First</button>
            <button onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))} disabled={currentPage === 0} className={styles.paginationButton}>Prev</button>
            <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
            <button onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Next</button>
            <button onClick={() => setCurrentPage(totalPages - 1)} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Last</button>
          </div>
        </div>
      )}

      {isModalOpen && selectedInvoice && (
        <InvoiceCard invoice={selectedInvoice} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default InvoiceTable;